module.exports = __webpack_public_path__ + "img/[猪头].24d97ad4.svg";